import type { Environment } from './interface';

export const staging2: Environment = {
  apiBusinessGqlUrl: 'https://stg2-business-center.pipelinersales.com/api/business/graphql',
  apiCustomerGqlOrigin: 'https://stg2-customer-portal.pipelinersales.com',
  apiUserGqlUrl: 'https://stg2-api.pipelinersales.com/api/user/graphql',
  apiSchedulerGqlUrl: 'https://stg2-api.pipelinersales.com/api/scheduler/public/graphql',
  apiOnlineFormGqlUrl: 'https://stg2-api.pipelinersales.com/api/online-form/public/graphql',
  apiPublicGqlUrl: 'https://stg2-api.pipelinersales.com/api/public/graphql',
  businessCenterUrl: 'https://stg2-business-center.pipelinersales.com',
  customerPortalUrl: 'https://stg2-customer-portal.pipelinersales.com',
  partnerPortalUrl: 'https://stg2-partner-portal.pipelinersales.com',
  crmUrl: 'https://stg2-crm.pipelinersales.com',
  schedulerUrl: 'https://stg2-scheduler.pipelinersales.com',
  signUpUrl: 'https://staging-wordpress.pipelinersales.com/crm/free-trial/',
  ssoUrl: 'https://stg2-accounts.pipelinersales.com',
  formsUrl: 'https://stg2-forms.pipelinersales.com'
};
